module.exports = __webpack_public_path__ + "static/img/icons8.74a79088.gif";